import {
    ExpandOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { Space } from 'antd';
import { useNavigate } from 'react-router';
import { useAuth } from '../../contexts/AuthContext';
import { toggleFullscreen } from '../../helpers/fullScreen';
import './style.css';

export type HeaderProps = {
    showLogoutButton?: boolean;
}

export default function HeaderPrincipal({ showLogoutButton = true }: HeaderProps) {
    let navigate = useNavigate();

    const { handleLogout } = useAuth();

    return (
        <div className='HeaderPrincipal'>
            <div className='LogoAndTrigger'>
                <a onClick={() => navigate('/inicio')}><img src='/fslogo.png' width={20} height={30} alt="Logo Marca da aplicação FSJus"></img></a>
                FONTENELE & SEREJO - Advocacia
            </div>
            <div className='logoutAndSettings'>
                <Space >
                    <ExpandOutlined style={{ fontSize: '18px' }} onClick={toggleFullscreen} />
                    {showLogoutButton && <LogoutOutlined style={{ fontSize: '18px' }} onClick={handleLogout} />}
                </Space>
            </div>
        </div>
    )
}
